/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

export enum PropertyType {
  array = 'array',
  boolean = 'boolean',
  blank = 'blank',
  camera = 'camera',
  checklist = 'checklist',
  checkbox = 'checkbox',
  combo = 'combo',
  country = 'country',
  date = 'date',
  dateTime = 'dateTime',
  currency = 'currency',
  duration = 'duration',
  editTable = 'editTable',
  formTable = 'formTable',
  file = 'file',
  hide = 'hide',
  inputpicker = 'inputpicker',
  inss = 'inss',
  interval = 'interval',
  immat = 'immat',
  list = 'list',
  mail = 'mail',
  modal = 'modal',
  number = 'number',
  object = 'object',
  password = 'password',
  photo = 'photo',
  progress = 'progress',
  radio = 'radio',
  radiolight = 'radiolight',
  scheduler = 'scheduler',
  search = 'search',
  signature = 'signature',
  string = 'string',
  switch = 'switch',
  button = 'button',
  tel = 'tel',
  textarea = 'textarea',
  time = 'time',
  link = 'link',
  tag = 'tag',
  title = 'title',
  tva = 'tva',
  subsection = 'subsection',
  color = 'color',
  richText = 'richText',
  icon = 'icon',
  gallery = 'gallery',
  intervalDoublePicker = 'intervalDoublePicker',
}
